const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermissionW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0999749,0,0,0.102674,1.28925,0.999961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.926,55.171C196.816,49.386 196.711,43.921 196.711,38.634C196.711,34.492 193.354,31.134 189.211,31.134C157.136,31.134 132.715,21.916 112.359,2.124C109.447,-0.708 104.813,-0.707 101.902,2.124C81.548,21.916 57.131,31.134 25.058,31.134C20.916,31.134 17.558,34.492 17.558,38.634C17.558,43.922 17.454,49.389 17.343,55.175C16.315,109.011 14.907,182.742 104.674,213.857C105.47,214.133 106.3,214.271 107.13,214.271C107.96,214.271 108.791,214.133 109.586,213.857C199.36,182.741 197.954,109.008 196.926,55.171ZM107.131,198.812C30.144,170.845 31.308,109.58 32.341,55.461C32.403,52.213 32.463,49.065 32.505,45.979C62.545,44.711 86.567,35.608 107.131,17.694C127.697,35.608 151.723,44.712 181.765,45.979C181.807,49.064 181.867,52.21 181.929,55.456C182.961,109.577 184.124,170.844 107.131,198.812Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.958,81.082L96.759,117.279L81.312,101.832C78.383,98.904 73.634,98.904 70.706,101.832C67.777,104.762 67.777,109.51 70.706,112.439L91.456,133.189C92.92,134.653 94.84,135.385 96.759,135.385C98.678,135.385 100.598,134.653 102.062,133.189L143.563,91.689C146.493,88.76 146.493,84.011 143.564,81.083C140.636,78.154 135.887,78.153 132.958,81.082Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionW);
export default __webpack_public_path__ + "static/media/permission-w.82513e278f6b2342b9442627c388eb72.svg";
export { ForwardRef as ReactComponent };